import axios from 'axios'

export const exportExcel = async (filename, workbook) => {
  try {
    const resp = await axios.post(
      'https://spreadsheet-generator.reges.se/xlsx',
      workbook,
      {
        responseType: 'blob',
        auth: {
          username: 'dced0cdb-1a9f-40c8-aac0-1e674b8e1975',
          password: 'c0529f0b-3e9d-4873-9a9d-27a14739b83c',
        },
      },
    )

    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(resp.data, filename + '.xlsx')
    } else {
      const a = document.createElement('a')
      const url = URL.createObjectURL(resp.data)
      a.href = url
      a.target = '_blank'
      a.download = filename + '.xlsx'
      document.body.appendChild(a)
      a.click()
    }
  } catch (err) {
    console.log(err)
  }
}
